import { render, staticRenderFns } from "./SetupPage.vue?vue&type=template&id=30abffc7&lang=pug&"
import script from "./SetupPage.vue?vue&type=script&lang=js&"
export * from "./SetupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports